var btn_start = document.querySelector('#btn-quiz-start')
var intro = document.querySelector('#quiz-intro')
var form = document.querySelector('#quiz')
var header = document.querySelector('#quiz #header')
var step = document.querySelector('#quiz #step')
var current = document.querySelector('#quiz #current')
var total = document.querySelector('#quiz #total')
var btn_back = document.querySelector('#quiz #btn-step-back')
var progress = document.querySelector('#quiz #progress')

var answers = []

if (!btn_start) return

btn_start.addEventListener('click', function () {
  intro.classList.add('hidden')
  form.classList.remove('hidden')
  changeToStep(step)
})

quiz.addEventListener('change', function (event) {
  const last = total.value - 1
  if (step.value == last) {
    changeToProcessing()
    setTimeout(function () {
      form.submit()
    }, 3000)
    return
  }

  btn_back.removeAttribute('disabled')

  if (event.target.type === 'radio' && event.target.checked) {
    answers[step.value] = event.target.value
    step.value = Number(step.value) + 1
    changeToStep(step)
  }
})

btn_back.addEventListener('click', function () {
  if (step.value > 1) {
    step.value = Number(step.value) - 1

    changeToStep(step)

    document.querySelector(
      'div[data-step="' + step.value + '"] input[type="radio"]:checked'
    ).checked = false
  }
  if (step.value == 1) btn_back.setAttribute('disabled', 'disabled')
})

function changeToStep(step) {
  hiddenAllSteps()

  document
    .querySelector('div[data-step="' + step.value + '"]')
    .classList.remove('hidden')

  current.innerHTML = step.value

  setTimeout(function () {
    progress.style.width = (step.value / total.value) * 100 + '%'
  }, 100)
}

function changeToProcessing() {
  header.classList.add('hidden')
  hiddenAllSteps()
  document.querySelector('div[data-step="8"]').classList.remove('hidden')
}

function hiddenAllSteps() {
  var steps = document.querySelectorAll('div[data-step]')

  for (var i = 0; i < steps.length; i++) {
    steps[i].classList.add('hidden')
  }
}
